
<template>
      

  <aside class="menustyle ">
          <DxScrollView
        id="scrollview"
        ref="scrollViewWidget"
        :scroll-by-thumb="scrollByThumb"
        :show-scrollbar="showScrollbar"
        :bounce-enabled="pullDown"
        reach-bottom-text="Updating..."
        @pull-down="updateTopContent"
        @reach-bottom="updateBottomContent"
      >
      <ul class="flex flex-col items-center mt-2 ">
          <jet-responsive-nav-link   :active="route().current('dashboard')" :href="'/dashboard'" class=" w-full text-gray-400 ">
                    <i class="fas fa-th mr-3"></i>
                  <span class="link-label">Dashboard</span>
        </jet-responsive-nav-link>
      <!-- :href="'/integrate?is_license_valid='+is_valid_license+'&is_electron='+is_electron+'&license_from_database='+license_no" -->
       <jet-responsive-nav-link  :active="route().current('tc-integrates.index','tc')"  :href="'/tc/tc-integrates'" class=" w-full text-gray-400 ">
        <i class="fas fa-signal mr-3"></i>
          <span class="link-label">Integrate</span>
      </jet-responsive-nav-link>
      <!--  -->
          <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-tools mr-3"></i>
                  <span class="link-label">Manage</span>
        </jet-responsive-nav-link>
      <!--  -->
         <jet-responsive-nav-link  :href="'/comingsoon'" class="block w-full text-gray-400 ">
                  <i class="fas fa-tasks mr-3"></i>
                  <span class="link-label">Print</span>
        </jet-responsive-nav-link>
      <!--  -->
          <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-users mr-3"></i>
                  <span class="link-label">Report</span>
          </jet-responsive-nav-link>
      <!--  -->
         <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400">
                  <i class="fas fa-chart-line mr-3"></i>
                  <span class="link-label">Analyse</span>
        </jet-responsive-nav-link>
      <!--  -->
         <jet-responsive-nav-link   :href="'/comingsoon'" class=" w-full  text-gray-400 ">
                  <i class="fas fa-sync mr-3"></i>
                  <span class="link-label">Sync</span>
        </jet-responsive-nav-link>
      <!--  -->
           <jet-responsive-nav-link   :href="'/comingsoon'" class="w-full text-gray-400 ">
                  <i class="fas fa-comments mr-3"></i>
                  <span class="link-label">Tally-on-Cloud</span>
        </jet-responsive-nav-link>
      <!--  -->
          <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-puzzle-piece mr-3"></i>
                  <span class="link-label">Add-Ons</span>
        </jet-responsive-nav-link>
      <!--  -->
         <jet-responsive-nav-link  :href="'/comingsoon'" class="w-full  text-gray-400 ">
                  <i class="fas fa-cubes mr-3"></i>
                  <span class="link-label">Modules</span>
        </jet-responsive-nav-link>
      <!--  -->
          <jet-responsive-nav-link :href="'/comingsoon'" class="w-full  text-gray-400 ">
                  <i class="fas fa-cogs mr-3"></i>
                  <span class="link-label">Services</span>
        </jet-responsive-nav-link>
      <!--  -->
           <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400 ">
                  <i class="fas fa-user-astronaut mr-3"></i>
                  <span class="link-label">Trainings</span>
        </jet-responsive-nav-link>
      <!--  -->
        <jet-responsive-nav-link  :href="'/comingsoon'" class=" w-full text-gray-400">
                  <i class="fas fa-handshake mr-3"></i>
                  <span class="link-label">Webinars</span>
        </jet-responsive-nav-link>
      <!--  -->
    </ul>
            
      </DxScrollView>
  </aside>

</template>

<script>
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import { DxScrollView } from 'devextreme-vue/scroll-view';

export default {
components:{
JetResponsiveNavLink,
DxScrollView
},
 data:function(){
    return{
      pullDown: false,
      showScrollbar: 'onScroll',
      scrollByContent: true,
      scrollByThumb: true,
    }
  },
mounted(){

}
}
</script>

<style>
.menustyle{
      /* padding:0px 12px; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
   height: 91vh;
    text-align: left;
}

</style>